import { useMemo } from 'react';
import { useGetTotalActiveInvitedAndDeactivatedQueary } from 'src/features/Settings/UserManagement/queries';
import { IModdedUserInfo } from 'src/features/Settings/UserManagement/queries/apiTypes';

export function useActiveUsers(createDataMapping: boolean = false) {
    const [{ data, ...restQueryProps }] = useGetTotalActiveInvitedAndDeactivatedQueary(['active']);

    const dataMap = useMemo(() => {
        const map = new Map<number, IModdedUserInfo>();
        if (!data?.data || !createDataMapping) return map;

        data.data.forEach((user) => {
            map.set(user.user_details.id, user);
        });

        return map;
    }, [data?.data, createDataMapping]);

    return {
        data,
        ...restQueryProps,
        dataMap
    };
}
